import React from 'react';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';
import Avatar from './Avatar';
import RobotIcon from '../icons/RobotIcon';
import { useT } from '../../i18n';

const MONO = 'ui-monospace, SFMono-Regular, Menlo, monospace';

const useStyles = createUseStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '10px',
    padding: '8px 12px',
    paddingTop: 'calc(8px + env(safe-area-inset-top, 0px))',
    background: '#1a0f0a',
    borderBottom: '1px solid #4a3020',
    boxShadow: '0 1px 0 rgba(255,255,255,0.05)',
    zIndex: 10,
    position: 'relative',
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    minWidth: 0,
  },
  hamburger: {
    width: '44px',
    height: '44px',
    flexShrink: 0,
    background: '#2a1d13',
    border: '1px solid #4a3020',
    borderRadius: '8px',
    color: '#e8d6ae',
    fontSize: '18px',
    cursor: 'pointer',
    fontFamily: 'inherit',
    lineHeight: 1,
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.1)',
    '&:active': {
      boxShadow: 'inset 0 2px 5px rgba(0,0,0,0.5)',
    },
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    minWidth: 0,
    minHeight: '44px',
    textDecoration: 'none',
    color: 'inherit',
    '&:active': { filter: 'brightness(1.2)' },
  },
  mark: {
    width: '22px',
    height: '22px',
    flexShrink: 0,
  },
  title: {
    color: '#f5e6c8',
    fontWeight: 700,
    fontSize: '15px',
    letterSpacing: '2.5px',
    textTransform: 'uppercase',
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  selfBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '7px',
    height: '44px',
    padding: '0 10px 0 6px',
    background: '#2a1d13',
    border: '1px solid #4a3020',
    borderRadius: '22px',
    cursor: 'pointer',
    fontFamily: 'inherit',
    flexShrink: 0,
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.08)',
    '&:active': {
      boxShadow: 'inset 0 2px 5px rgba(0,0,0,0.5)',
    },
  },
  selfName: {
    fontFamily: MONO,
    color: '#d9c3a2',
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '0.5px',
    maxWidth: '84px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

function MobileHeader({ players, selfId, nickname, onMenuOpen, onNicknameClick, onLeave }) {
  const classes = useStyles();
  const t = useT();

  const selfPlayer = players?.find(p => p.id === selfId);
  const displayName = nickname || selfPlayer?.username || t('game.player');

  return (
    <div className={classes.header}>
      <div className={classes.left}>
        <button className={classes.hamburger} onClick={onMenuOpen} aria-label={t('a11y.menu')}>
          ☰
        </button>
        <Link className={classes.brand} to="/" title={t('a11y.backToMenu')} onClick={onLeave}>
          <div className={classes.mark}>
            <RobotIcon color="#d94f2b" />
          </div>
          <h1 className={classes.title}>Robotrons</h1>
        </Link>
      </div>
      {selfPlayer && (
        <button className={classes.selfBtn} onClick={onNicknameClick}>
          <Avatar photoURL={selfPlayer.avatar} color="#d94f2b" size={30} />
          <span className={classes.selfName}>{displayName}</span>
        </button>
      )}
    </div>
  );
}

export default MobileHeader;
